import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Feed, Icon,Button, Image } from 'semantic-ui-react';

import Utils from '../../utils/Utils.js';
import {colors, fontSizes, fonts, spacings, layout, shadow, shadowLight} from 'style';
import Render0Block from './Render0Block';



const Palette = {
    primary: colors.themeBlue,
    secondary: colors.themeTeal,
    points: colors.pointsYellow,
    body: colors.themeDarkerGrey,
    subtext: colors.themeDarkGrey,
    warning: colors.warningRed
};

const Sizes = {
    caption: '12px',
    subtext: '14px',
    body: '16px',
    header: '18px',
    title: '20px',
    h2: '24px',
    h1: '32px',
    x1: '40px'
}

const Margins = {
    default: '16',
    none: '0',
    micro: '1',
    mini: '2',
    tiny: '4',
    small: '8',
    medium: '16',
    large: '24',
    xlarge: '32',
    xxlarge: '48',
    xxxlarge: '64',
}

const Alignments = {
    left: 'left',
    center: 'center',
    right: 'right'
}

const style = {
    iconChevronRightFloated: {
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        marginLeft: '420px'
    },
}


const Render2Block = ({t, content, onAction, getData}) => (
    <div style={{backgroundColor: colors.themeNearWhite}}>
        <Render0Block content={content} t={t} onAction={onAction} />
        {Boolean(getData(Boolean(content.key) ? t(content.key) : content.data, content.args, content, Palette, Margins, Sizes, Alignments)) && 
        <div style={{padding: spacings.small}}>
            {getData(Boolean(content.key) ? t(content.key) : content.data, content.args, content, Palette, Margins, Sizes, Alignments)}
            {Boolean(content.navigation) && <Icon className="icon-chevron-right" style={style.iconChevronRightFloated} />}
        </div>}
    </div>


);

export default Render2Block;


// WEBPACK FOOTER //
// ./src/modules/newsfeed/Render2Block.js